import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  applicationVersion: 'pm1.2',
  applicationName: 'PerformanceReportsClient',
  environment: 'PROD',

  // Security
  UseCookies: true,

  StorageID: 'indicator-factory-store',
  AccessTokenID: 'indicator-factory-token',
  TokenIDExpires: 'indicator-factory-token-expires',
  TokenEmail: 'indicator-factory-token-email',
  PendoUserID: 'indicator-factory-pendo-userid',
  HospitalId: 'indicator-factory-hospid',
  HospitalName: 'indicator-factory-hospname',
  UnitId: 'indicator-factory-unitid',
  IndicatorId: 'indicator-factory-indid',
  TokenSubscriptionsAvailable: 'indicator-factory-token-subscriptionsavailable',
  SubscriptionSelected: 'indicator-factory-subscription-selected',

  Webserver: 'https://members.nursingquality.org',

  // API's
  Api: 'https://members.nursingquality.org/apis/PerformanceReportsBusinessApi/api/',
  BusinessApi: 'https://members.nursingquality.org/apis/PerformanceReportsBusinessApi/api/business',
  Assets: 'assets/',
  LocalJsonApi: 'assets/json/',

  // Logging
  LogService: 'https://members.nursingquality.org/apis/CentralizedLoggingAPI/api/log/LogData',
  LogMedia: 'application/pg.centralizedloggingapi.logobject+json',
  LogLevel: NgxLoggerLevel.WARN,
  ServerLogLevel: NgxLoggerLevel.WARN,
  DisableConsoleLogging: true,

  // Services
  UseBusinessServerQuarterTrends: true,
  UseBusinessServerBenchmarks: true,
  UseBusinessServerParams: true,
  UseBusinessServerPerformanceDetails: true,
  UseBusinessMeasureList: true,

  // Media Types
  GetSysPerformanceParamMedia: 'application/pg.performancereportsbusinessapi.getsysperfparameters+json',
  GetQuarterTrendMedia: 'application/pg.performancereportsbusinessapi.getlinechartbyhospital+json',
  GetBenchmarksMedia: 'application/pg.performancereportsbusinessapi.getbenchmarkperformance+json',
  GetPerformanceDetailMedia: 'application/pg.performancereportsbusinessapi.getdetailsbyhospmeasure+json',
  GetMesauresListMedia: 'application/pg.performancereportsbusinessapi.getmeasureslist+json',

  // Misc
  DefaultBenchMarkId: 18

};

